<!-- Barra de menu-->
<navbar-component></navbar-component>

<main class="background">

  <div class="head">
    <img src="./../../assets/icons/eventos-icon.svg" alt="Ícone Eventos" id="head-icon">
    <div class="container-title">
        <div class="title">
            Eventos
        </div>
    </div>
  </div>

  <div class="events-container">
    <div>
      <div class="events-list">
        <div class="collection" *ngFor="let event of events">
          <a style="cursor: pointer;" (click)="openPreview(event.id)" class="collection-item">{{event.name}}</a>
        </div>
      </div>
    </div>

    <img *ngIf="!isMobileLayout" class="painting" src="./../../assets/fotos/painting.svg">
    <img *ngIf="isMobileLayout" class="painting" src="./../../assets/fotos/painting-vertical.svg">


  </div>

  <ngx-gallery #gallery [options]="galleryOptions" [images]="galleryImages" style="width: 0; height: 0;">
  </ngx-gallery>

</main>

<!-- Footer and copyright -->
<footer-component></footer-component>
